import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

type Args = {
  nextSortId?: (number | string)[];
  prevSortId?: (number | string)[];
};

const usePagingAfter = ({ nextSortId, prevSortId }: Args) => {
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<PaginationLimit>(25);
  const [searchAfter, setSearchAfter] = useState<(number | string)[] | undefined>(undefined);
  const [reverseSort, setReverseSort] = useState<boolean>(false);

  const router = useRouter();

  const onPageChange = (newSeriesData: string) => {
    setPage(Number(newSeriesData));
  };

  const onRowsPerPageChange = (newSeriesData: PaginationLimit) => {
    setRowsPerPage(newSeriesData);
    setSearchAfter(undefined);
    setReverseSort(false);
    setPage(1);
  };

  const resetPage = useCallback(() => {
    setSearchAfter(undefined);
    setReverseSort(false);
    setPage(1);
  }, []);

  const onPrevPageClick = () => {
    setSearchAfter(prevSortId);
    setReverseSort(true);
    setPage((prevValue) => prevValue - 1);
  };

  const onNextPageClick = () => {
    setSearchAfter(nextSortId);
    setReverseSort(false);
    setPage((prevValue) => prevValue + 1);
  };

  const onGoToSearchPress = (
    scope: 'loan-officers' | 'agents' | 'agents/teams' | 'opportunities'
  ) => {
    router.push(`/${scope}/search`);
  };

  return {
    page,
    rowsPerPage,
    resetPage,
    onGoToSearchPress,
    onPageChange,
    onRowsPerPageChange,
    onPrevPageClick,
    onNextPageClick,
    reverseSort,
    searchAfter,
  };
};

export default usePagingAfter;
